const SvgReportsStatus = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="14" height="14" rx="7" fill="#E22828" />
    <path
      d="M5.5 9.4H8.5V8.6H5.5V9.4ZM5.5 7.8H8.5V7H5.5V7.8ZM4.75 11C4.54375 11 4.36719 10.9217 4.22031 10.765C4.07344 10.6083 4 10.42 4 10.2V3.8C4 3.58 4.07344 3.39167 4.22031 3.235C4.36719 3.07833 4.54375 3 4.75 3H7.75L10 5.4V10.2C10 10.42 9.92656 10.6083 9.77969 10.765C9.63281 10.9217 9.45625 11 9.25 11H4.75ZM7.375 5.8V3.8H4.75V10.2H9.25V5.8H7.375Z"
      fill="white"
    />
  </svg>
)

export default SvgReportsStatus
